/** Scripts written without spaces between words (Chinese, Japanese, Thai). */
const UNSPACED_LOCALES = new Set(["zh", "ja", "th"]);
/** zh/th catalogs space Latin words (e.g. the "Mark Egly" brand) off from native script. */
const SPACE_AROUND_LATIN = new Set(["zh", "th"]);
/**
 * ja spaces a Latin word off from the kana that follows it ("Mark Egly ゴルフ", WQA #126),
 * but keeps a particle-ended lead flush against a Latin accent ("競技成績とPGAツアー経験").
 */
const SPACE_AFTER_LATIN = new Set(["ja"]);
const ASCII_VISIBLE = /^[!-~]$/;
/**
 * Arabic "and" (و) and Hebrew "and" (ו) are prefixes written flush against the next word
 * ("الصور ومقاطع", "מחנות וסדנאות"). A lead ending in a detached conjunction must not get a space.
 */
const TRAILING_PREFIX_CONJUNCTION: Record<string, RegExp> = {
  ar: /(?:^|\s)و$/u,
  he: /(?:^|\s)ו$/u,
};
const LATIN_ALNUM = /^[A-Za-z0-9]$/;

/**
 * Text placed between `lead` and `accent`. Spaced locales (including ko, whose lead/accent
 * pairs are split at word boundaries) get " ". zh/ja/th get "", except where both sides of
 * the seam are ASCII (e.g. "Des Moines" + "Driving Range") so Latin words never fuse.
 * zh/th also get " " when either side of the seam is a Latin letter or digit
 * (e.g. th "แชมป์ที่ Mark" + "ช่วยปั้น"), matching how those catalogs space Latin words.
 * ja gets " " only when the lead ends in a Latin letter or digit.
 * ar/he get "" when the lead ends in the conjunction و / ו, which attaches to the accent's first word.
 */
export function titleJoiner(locale: string, lead: string, accent: string): string {
  if (TRAILING_PREFIX_CONJUNCTION[locale]?.test(lead.trimEnd())) return "";
  if (!UNSPACED_LOCALES.has(locale)) return " ";
  const last = lead.slice(-1);
  const first = accent.slice(0, 1);
  if (ASCII_VISIBLE.test(last) && ASCII_VISIBLE.test(first)) return " ";
  if (SPACE_AROUND_LATIN.has(locale) && (LATIN_ALNUM.test(last) || LATIN_ALNUM.test(first))) {
    return " ";
  }
  if (SPACE_AFTER_LATIN.has(locale) && LATIN_ALNUM.test(last)) return " ";
  return "";
}
